module.exports = __webpack_public_path__ + "static/20-7bd7d91a9f4262259d69783937f0ec97.jpeg";